/* ============================================================================
 * ============================================================================
 * ====                                                                    ====
 * ====   KIT BUILDER  →  SHOPIFY  PERSONALIZATION  MAP                     ====
 * ====                                                                    ====
 * ====   *** THIS IS THE FILE TO EDIT to add / remove options. ***        ====
 * ====                                                                    ====
 * ============================================================================
 * ============================================================================
 *
 * WHAT THIS IS
 * ------------
 * Kit Builder and Shopify do NOT use the same names or values for the same
 * option. This map is the single, explicit translation table between them.
 * Each row spells out all three independent identities — nothing is assumed
 * to line up:
 *
 *   kbFieldKey        The Kit Builder field key, taken from the webhook payload
 *                     at  SingleItemCheckout.Fields[].Key
 *                     (e.g. "picker-pocket"). This is how we find the option in
 *                     the Kit Builder data.
 *
 *   shopifyOptionName The `name` of the matching personalization option in the
 *                     Shopify variant metafield  custom.personalizations
 *                     (e.g. "Custom Hoodie Pocket"). Shopify is the source of
 *                     truth for the label, the price and how it's saved.
 *
 *   valueMap          Translates the Kit Builder selected value -> the Shopify
 *                     option `key`. Kit Builder might send "Yes" while Shopify's
 *                     key is "YES" — or they could be completely different. List
 *                     every value you expect Kit Builder to send.
 *
 * HOW IT BEHAVES (handled in kitbuilder-integration.js, not here)
 * --------------------------------------------------------------
 *   • Kit Builder value of null / "" / "N/A"  -> option is treated as NOT
 *     selected: nothing is written to the cart line and no upcharge is added.
 *   • A value that isn't listed in valueMap     -> skipped (console.warn).
 *   • A Shopify option/key that can't be found  -> skipped (console.warn).
 *   • The PRICE always comes from Shopify's personalizations record, never from
 *     this file and never from Kit Builder. Change a price in Shopify admin and
 *     the cart line follows automatically (and re-calculates on quantity change
 *     via the existing cart price function).
 *
 * TO ADD AN OPTION
 * ----------------
 *   1. Find its Kit Builder field key (SingleItemCheckout.Fields[].Key).
 *   2. Find the matching Shopify personalization option `name` on the variant.
 *   3. Add a row below mapping each Kit Builder value to the Shopify option key.
 *
 * TO REMOVE AN OPTION
 * -------------------
 *   Delete (or comment out) its row. The option simply stops being mirrored.
 * ============================================================================
 */
window.KitBuilderPersonalizationMap = [
  {
    kbFieldKey: 'picker-pocket', // Kit Builder: Front Pocket dropdown
    shopifyOptionName: 'Custom Hoodie Pocket', // Shopify: custom.personalizations option name
    valueMap: {
      // Kit Builder value : Shopify option key
      Yes: 'YES',
      No: 'NO'
    }
  }
];
